export default function RenderJSON({ item }) {
  const content = JSON.parse(item?.data);
  return <p>{content.text || content.title}</p>;
}
